import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITestCoverageService = ( createDecorator('testCoverageService'));
export { ITestCoverageService };
